export const PreferencesColumns = [
    {
        name: 'Тема подписки',
        key: 'preference',
    },
    {
        name: 'Email',
        key: 'email',
    },
    {
        name: 'Имя',
        key: 'name',
    },
    {
        name: 'Источник',
        key: 'pipelineSource',
    },
    {
        name: 'Дата и время подписки',
        key: 'createdAt',
    },
]

export const LeadsColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Имя',
        key: 'name',
    },
    {
        name: 'Компания',
        key: 'companyName',
    },
    {
        name: 'Телефон',
        key: 'phoneNumber',
    },
    {
        name: 'Источник',
        key: 'source',
    },
    {
        name: 'Комментарий',
        key: 'comment',
    },
    {
        name: 'Email',
        key: 'email',
    },
    {
        name: 'Дата создания',
        key: 'createdAt',
    },
]
